// components
import HeaderLeft from './HeaderLeft';
import HeaderRight from './HeaderRight';
import usePageTitle from '../../hooks/usePageTitle';

// interfaces
interface IProps {
  icon?: string;
  title: string | React.ReactNode;
  metaTitle?: string;
}

const Header: React.FC<IProps> = ({ icon, title, metaTitle }) => {
  usePageTitle(metaTitle || (typeof title === 'string' ? title : 'Kanea'));
  
  return (
    <header className='flex flex-center flex-space-between'>
      <HeaderLeft icon={icon} title={title} />
      <HeaderRight />
    </header>
  );
};

export default Header;
